import React, { useState } from 'react';

export function ChecklistCard({ title = 'Lista de Tarefas', items = [] }) {
  const [checked, setChecked] = useState(() => items.map(it => it.done));

  const toggle = (i) => setChecked(prev => prev.map((v, j) => j === i ? !v : v));
  const doneCount = checked.filter(Boolean).length;
  const pct = items.length > 0 ? Math.round((doneCount / items.length) * 100) : 0;

  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)' }}>
          {title}
        </span>
        <span style={{ fontSize: 10.5, color: doneCount === items.length ? '#10b981' : 'rgba(100,116,139,0.65)' }}>
          {doneCount}/{items.length} · {pct}%
        </span>
      </div>

      {/* Mini progress */}
      <div style={{ height: 2, background: 'rgba(255,255,255,0.05)', borderRadius: 1, overflow: 'hidden', marginBottom: 12 }}>
        <div style={{ width: `${pct}%`, height: '100%', background: '#10b981', transition: 'width .4s ease' }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
        {items.map((item, i) => (
          <button
            key={i}
            onClick={() => toggle(i)}
            style={{
              display: 'flex', alignItems: 'flex-start', gap: 9,
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '4px 0', textAlign: 'left', fontFamily: 'inherit',
            }}
          >
            <span style={{
              flexShrink: 0, width: 15, height: 15, marginTop: 1,
              border: `1.5px solid ${checked[i] ? '#10b981' : 'rgba(100,116,139,0.4)'}`,
              borderRadius: 3, background: checked[i] ? '#10b981' : 'transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all .2s ease',
            }}>
              {checked[i] && (
                <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
                  <path d="M1 3.5L3.5 6L8 1" stroke="#0a1020" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </span>
            <span style={{
              fontSize: 12.5, lineHeight: 1.45,
              color: checked[i] ? 'rgba(100,116,139,0.5)' : 'rgba(220,228,255,0.78)',
              textDecoration: checked[i] ? 'line-through' : 'none',
              transition: 'all .2s ease',
            }}>
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
